import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import "./css/index.css";
import { ReactComponent as ScrapSvg } from "./svg/scrap.svg";
import { ReactComponent as ApplySvg } from "./svg/apply.svg";
import { DdayChange, formatDate, makeComma, refundTime } from "../../lib/lib";
import Screen from "./Screen/Screen";

type Props = {
  Data: any;
  type: "project" | "meetup";
  categoryContent: string | undefined;
  price: string;
  isLook: boolean;
  Cancel: Dispatch<SetStateAction<boolean>>;
};

const LookProject = ({
  Data,
  type,
  categoryContent,
  price,
  isLook,
  Cancel,
}: Props) => {
  const ContentRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectField, setSelectField] = useState("");
  useEffect(() => {
    if (ContentRef.current) {
      ContentRef.current.innerHTML = Data.template;
    }

    return () => {};
  }, [Data.template]);

  return isLook ? (
    <div className="look-project-section">
      <button
        className="cancel-btn"
        onClick={() => {
          Cancel(false);
        }}
      >
        <img src="/assets/common/cancel.svg" alt="" />
      </button>
      <div className="wrapper">
        <div className="top">
          <div className="wrapper">
            <div className="right">
              <div className="category-wrapper">
                <div className={`category ${type}-category`}>
                  {categoryContent}
                </div>
                <ScrapSvg />
              </div>
              <div className="title">{Data.title}</div>
              <div
                className="img-wrapper"
                style={{ backgroundImage: `url(${Data.mainimg})` }}
              />
              <div className="top-info">
                <div className="info-line">
                  <div className="tag">모집 일시</div>
                  <div className="per-wrapper">
                    <div className="period">
                      {formatDate(Data.period.start, "-")} ~
                      {formatDate(Data.period.finish, "-")}
                    </div>
                    <div className="d-day">
                      D-{DdayChange(Data.period.finish)}
                    </div>
                  </div>
                </div>

                <div className="info-line">
                  <div className="tag">
                    {type === "project" ? "팀플 시작" : "밋업 시작"}
                  </div>
                  <div className="field">
                    {formatDate(Data.finish_time, "-")}
                  </div>
                </div>
                {Data.prjt_type_cd === "mtup" ? (
                  <div className="info-line">
                    <div className="tag">모집 인원</div>
                    <div className="field">
                      <span>0</span>/
                      {Data.category === "OFFLINE" ? 0 : "제한없음"}
                    </div>
                  </div>
                ) : undefined}
                <div className="info-line">
                  <div className="tag">팀 리더</div>
                  <div className="leader">
                    <div className="name">{Data.leader.name}</div>
                  </div>
                </div>
              </div>
              <div className="position">{Data.leader.sub}</div>
              <div className="line" />
              <div className="price-wrapper">
                <div className="title">참가비</div>
                <div className="price">{makeComma(price)}원</div>
              </div>

              {type === "project" ? (
                <div className={`mb-field ${isOpen ? "mb-active" : ""}`}>
                  <button
                    className="close-btn"
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  >
                    <img src="/assets/common/grey-arrow.svg" alt="" />
                  </button>
                  <div className="title">신청 분야를 선택해주세요</div>
                  <div className="field-list">
                    {Data.field.detail.map((item: any, idx: number) => {
                      return (
                        <button
                          key={idx}
                          className={`select `}
                          onClick={() => {}}
                        >
                          <div className="circle">
                            <img src="/assets/login/check.svg" alt="" />
                          </div>
                          {item.rcrt_nm}
                        </button>
                      );
                    })}
                  </div>
                  <button
                    className="select-btn"
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  >
                    선택 완료
                  </button>
                </div>
              ) : undefined}
              <button
                className="insert"
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
              >
                <ApplySvg />
                신청하기
              </button>
            </div>
          </div>
        </div>
        <div className="info-section">
          <div className="leader-section">
            <div className="wrapper">
              <div className="title">팀 리더 소개</div>
              <img src={Data.leader.img} alt="" />
              <div className="leader-title">{Data.leader.title}</div>
              <div className="sub">{Data.leader.intro}</div>
              <a href={Data.leader.link} target={"_blank"} rel="noreferrer">
                <div className="left-wrapper">
                  <div className="icon-wrapper">
                    <img src="/assets/common/link.svg" alt="" />
                  </div>
                  <div className="title">포트폴리오 확인하기</div>
                </div>
                <img
                  src="/assets/common/grey-arrow.svg"
                  alt=""
                  className="arrow"
                />
              </a>
            </div>
          </div>
          <div className="intro-section">
            <div className="wrapper">
              <div className="section-title">팀 프로젝트 소개</div>
              <Screen data={Data.template} />
              {Data.field?.detail ? (
                <div className="field-wrapper">
                  <div className="title">모집분야 및 인원</div>
                  <div className="field-list">
                    {Data.field.detail.map(
                      (
                        {
                          rcrt_nm,
                          rcrt_ctts,
                          rcrt_type_cd,
                          rcrt_usr_cnt,
                          cnt_rcrt,
                        }: {
                          rcrt_nm: string;
                          rcrt_ctts: string;
                          rcrt_type_cd: string;
                          rcrt_usr_cnt: number;
                          cnt_rcrt: number;
                        },
                        idx: number
                      ) => {
                        return (
                          <div className="field-card" key={idx}>
                            <img
                              src={`/assets/project/${rcrt_type_cd}.svg`}
                              alt=""
                              className="category-icon"
                            />
                            <div className="left">
                              <div className="title">{rcrt_nm}</div>
                              <div className="people">
                                {cnt_rcrt}명 지원
                                <span> / {rcrt_usr_cnt}명 모집</span>
                              </div>
                              <div className="sub">{rcrt_ctts}</div>
                            </div>
                            <button className="insert">신청하기</button>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              ) : undefined}
            </div>
          </div>
          {Data.rewards && type === "project" ? (
            <div className="reward-section">
              <div className="wrapper">
                <img src="/assets/common/flag.svg" alt="" />
                <div className="title">
                  완주하면 <br /> 이런 것들을 보상받을 수 있어요!
                </div>
                <div className="reward-list">
                  {Data.rewards.map(
                    (
                      {
                        bnfit_nm,
                        bnfit_impt_fg,
                      }: {
                        bnfit_nm: string;
                        bnfit_impt_fg: boolean;
                      },
                      idx: number
                    ) => {
                      return (
                        <div
                          key={idx}
                          className="reward-card"
                          style={
                            bnfit_impt_fg
                              ? {
                                  backgroundColor: "#B8FF6C",
                                }
                              : undefined
                          }
                        >
                          <img src="/assets/common/black-check.svg" alt="" />
                          {bnfit_nm}
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>
          ) : type === "meetup" && Data.address.basic ? (
            ""
          ) : // <MtupPlace basic={Data.} detail={mtup_plc_detail} />
          undefined}
          <div className="penalty-section">
            <div className="wrapper">
              <div className="title">패널티 및 강퇴조건</div>
              <div className="penalty-list">
                {Data.pnlt_lst.map(
                  ({ bnfit_nm }: { bnfit_nm: string }, idx: number) => {
                    return (
                      <div key={idx} className="box-line">
                        {bnfit_nm}
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default LookProject;

const refundArr = [
  {
    title: "환불요청시점",
    content: "환불 금액",
  },
  {
    title: "결제일+1일",
    content: "전액 환불",
  },
  {
    title: "결제일+2일~4일",
    content: "2%",
  },
  {
    title: "결제일+3일~6일",
    content: "5%",
  },
  {
    title: "결제일+6일~10일",
    content: "7%",
  },
  {
    title: "결제일+10일~14일",
    content: "10%",
  },
];
